export default "__VITE_ASSET__CVLfl_jP__"